export default {
  data: '/admin/api/unit-of-measures/all-unit-of-measures',
  all: '/admin/api/unit-of-measures/all-unit-of-measures'
};
